import React, { useCallback } from 'react';

import {
	useUIAction,
	useUIState
} from '../../../contexts/UIContext';

import Alert from '../../Alert';

const ApiErrorAlert = () => {
	const { apiErrorAlert } = useUIState();
	const { setApiErrorAlert } = useUIAction();

	const handleClose = useCallback( () => setApiErrorAlert( false ), [ setApiErrorAlert ] );

	return (
		<>
			<Alert
				name="api-error-alert"
				heading="Error"
				message={ apiErrorAlert }
				open={ Boolean( apiErrorAlert ) }
				closeModal={ handleClose }
				type="error"
			/>
		</>
	);
};

export default ApiErrorAlert;
